import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(theme => ({
  container: {
    width: '100%',
    borderRadius: theme.box.borderRadius,
    borderWidth: 1,
    borderColor: theme.colors.borderColor,
    backgroundColor: theme.colors.background,
    paddingVertical: spacing.xs * 1.5,
    paddingHorizontal: spacing.m,
    gap: spacing.xs * 1.5,
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: spacing.xs,
    right: spacing.xs,
  },
}));
